import { cn } from '@/lib/cn';

import { stepDotsFor } from '../constants';
import type { StepId, WizardState } from '../types';

interface Props {
  current: StepId;
  sourceMode: WizardState['sourceMode'];
}

export function ProgressBar({ current, sourceMode }: Props) {
  const dots = stepDotsFor(sourceMode);
  // "confirm" is the terminal screen — keep the last visible dot lit.
  const lastDotId = dots[dots.length - 1].id;
  const effectiveCurrent: StepId = current === 'confirm' ? lastDotId : current;
  const currentIdx = dots.findIndex(d => d.id === effectiveCurrent);

  return (
    <div className="flex items-center gap-1.5 px-4">
      {dots.map((dot, idx) => {
        const isPast = idx < currentIdx;
        const isCurrent = idx === currentIdx;
        return (
          <div key={dot.id} className="flex items-center gap-1.5">
            <span
              aria-current={isCurrent || undefined}
              className={cn(
                'h-2 w-2 rounded-full transition-colors',
                (isPast || isCurrent) ? 'bg-brand' : 'bg-bg-tertiary',
                isCurrent && 'ring-2 ring-brand/30',
              )}
            />
            {idx < dots.length - 1 && (
              <span
                aria-hidden
                className={cn(
                  'h-px w-4 transition-colors',
                  isPast ? 'bg-brand' : 'bg-bg-tertiary',
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
